(function () {
	function initSiteNotice() {
		document.querySelectorAll('[data-site-notice-dismiss]').forEach(function (button) {
			button.addEventListener('click', function () {
				var notice = button.closest('.site-notice');

				if (notice) {
					notice.remove();
				}
			});
		});
	}

	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		setTimeout(initSiteNotice, 1);
		return;
	}

	document.addEventListener('DOMContentLoaded', initSiteNotice);
})();
